"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * User Service
 * Provides OIDC and Security endpoints as well as CRUD operations for SAVE and E-Verify Users and Points of Contact.
 *
 * The version of the OpenAPI document: 3.0.32
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyIDPApi = void 0;
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 * no description
 */
var LegacyIDPApi = /** @class */ (function (_super) {
    __extends(LegacyIDPApi, _super);
    function LegacyIDPApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * The \'app\' value is required. > Validation Error Codes:   * `APP_NOT_SUPPORTED`   * `GENERAL_VALIDATION`   * `USER_EMAIL_NOT_UNIQUE` > System Error Codes:   * `EMAIL_SEND_FAILED`   * `GENERAL_SYSTEM_ERROR`   * `INTERNAL_DATA_ERROR`
     * Sends a forgot logonId email for the user associated with the provided email address
     */
    LegacyIDPApi.prototype.forgotLogonIdRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.email === null || requestParameters.email === undefined) {
                            throw new runtime.RequiredError('email', 'Required parameter requestParameters.email was null or undefined when calling forgotLogonId.');
                        }
                        queryParameters = {};
                        if (requestParameters.email !== undefined) {
                            queryParameters['email'] = requestParameters.email;
                        }
                        if (requestParameters.app !== undefined) {
                            queryParameters['app'] = requestParameters.app;
                        }
                        headerParameters = {};
                        if (requestParameters.xB3TraceId !== undefined && requestParameters.xB3TraceId !== null) {
                            headerParameters['X-B3-TraceId'] = String(requestParameters.xB3TraceId);
                        }
                        if (requestParameters.xB3SpanId !== undefined && requestParameters.xB3SpanId !== null) {
                            headerParameters['X-B3-SpanId'] = String(requestParameters.xB3SpanId);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/legacy-idp/forgot-logon-id",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * The \'app\' value is required. > Validation Error Codes:   * `APP_NOT_SUPPORTED`   * `GENERAL_VALIDATION`   * `USER_EMAIL_NOT_UNIQUE` > System Error Codes:   * `EMAIL_SEND_FAILED`   * `GENERAL_SYSTEM_ERROR`   * `INTERNAL_DATA_ERROR`
     * Sends a forgot logonId email for the user associated with the provided email address
     */
    LegacyIDPApi.prototype.forgotLogonId = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.forgotLogonIdRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * The \'logonId\' and \'app\' values are required. User cannot be a webservice user, or have a DELETED, DEACTIVATED, or PENDING_REACTIVATION status > Validation Error Codes:   * `APP_NOT_SUPPORTED`   * `GENERAL_VALIDATION`   * `USER_NOT_AUTHORIZED_FOR_APP`   * `USER_ROLE_INVALID`   * `TOO_MANY_ATTEMPTS`   * `USER_IS_MFA_ENABLED` > System Error Codes:   * `EMAIL_SEND_FAILED`   * `GENERAL_SYSTEM_ERROR`   * `INTERNAL_DATA_ERROR`
     * Sends a one time code to the email of the associated logon ID
     */
    LegacyIDPApi.prototype.sendOTCRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.sendOneTimeCodeRequest === null || requestParameters.sendOneTimeCodeRequest === undefined) {
                            throw new runtime.RequiredError('sendOneTimeCodeRequest', 'Required parameter requestParameters.sendOneTimeCodeRequest was null or undefined when calling sendOTC.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.xB3TraceId !== undefined && requestParameters.xB3TraceId !== null) {
                            headerParameters['X-B3-TraceId'] = String(requestParameters.xB3TraceId);
                        }
                        if (requestParameters.xB3SpanId !== undefined && requestParameters.xB3SpanId !== null) {
                            headerParameters['X-B3-SpanId'] = String(requestParameters.xB3SpanId);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/legacy-idp/send-otc",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.SendOneTimeCodeRequestToJSON(requestParameters.sendOneTimeCodeRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * The \'logonId\' and \'app\' values are required. User cannot be a webservice user, or have a DELETED, DEACTIVATED, or PENDING_REACTIVATION status > Validation Error Codes:   * `APP_NOT_SUPPORTED`   * `GENERAL_VALIDATION`   * `USER_NOT_AUTHORIZED_FOR_APP`   * `USER_ROLE_INVALID`   * `TOO_MANY_ATTEMPTS`   * `USER_IS_MFA_ENABLED` > System Error Codes:   * `EMAIL_SEND_FAILED`   * `GENERAL_SYSTEM_ERROR`   * `INTERNAL_DATA_ERROR`
     * Sends a one time code to the email of the associated logon ID
     */
    LegacyIDPApi.prototype.sendOTC = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sendOTCRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Updates password for the user, for use by the legacyIdp. The id in the path must match the user id of the authenticated session. >  Validation Error Codes:   * `PASSWORD_MINIMUM_NOT_EXCEEDED`   * `PASSWORD_INVALID`   * `PASSWORD_DUPLICATE`   * `GENERAL_VALIDATION`   * `PASSWORD_MISMATCH` > System Error Codes:   * `GENERAL_SYSTEM_ERROR`   * `PASSWORD_SYSTEM_ERROR`
     * Updates the password for the user.
     */
    LegacyIDPApi.prototype.updatePasswordRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling updatePassword.');
                        }
                        if (requestParameters.passwordChangeBody === null || requestParameters.passwordChangeBody === undefined) {
                            throw new runtime.RequiredError('passwordChangeBody', 'Required parameter requestParameters.passwordChangeBody was null or undefined when calling updatePassword.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.xB3TraceId !== undefined && requestParameters.xB3TraceId !== null) {
                            headerParameters['X-B3-TraceId'] = String(requestParameters.xB3TraceId);
                        }
                        if (requestParameters.xB3SpanId !== undefined && requestParameters.xB3SpanId !== null) {
                            headerParameters['X-B3-SpanId'] = String(requestParameters.xB3SpanId);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/legacy-idp/{id}/password".replace("{" + "id" + "}", encodeURIComponent(String(requestParameters.id))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.PasswordChangeBodyToJSON(requestParameters.passwordChangeBody),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Updates password for the user, for use by the legacyIdp. The id in the path must match the user id of the authenticated session. >  Validation Error Codes:   * `PASSWORD_MINIMUM_NOT_EXCEEDED`   * `PASSWORD_INVALID`   * `PASSWORD_DUPLICATE`   * `GENERAL_VALIDATION`   * `PASSWORD_MISMATCH` > System Error Codes:   * `GENERAL_SYSTEM_ERROR`   * `PASSWORD_SYSTEM_ERROR`
     * Updates the password for the user.
     */
    LegacyIDPApi.prototype.updatePassword = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updatePasswordRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * The \'OTC\' and \'app\' request body values are required. > Validation Error Codes:   * `APP_NOT_SUPPORTED`   * `GENERAL_VALIDATION`   * `USER_NOT_AUTHORIZED_FOR_APP`   * `OTC_EXPIRED`   * `OTC_USED`   * `OTC_MISMATCH` > System Error Codes:   * `GENERAL_SYSTEM_ERROR`   * `INTERNAL_DATA_ERROR`
     * verifies if a OTC is valid
     */
    LegacyIDPApi.prototype.verifyOtcRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.verifyOTCRequest === null || requestParameters.verifyOTCRequest === undefined) {
                            throw new runtime.RequiredError('verifyOTCRequest', 'Required parameter requestParameters.verifyOTCRequest was null or undefined when calling verifyOtc.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.xB3TraceId !== undefined && requestParameters.xB3TraceId !== null) {
                            headerParameters['X-B3-TraceId'] = String(requestParameters.xB3TraceId);
                        }
                        if (requestParameters.xB3SpanId !== undefined && requestParameters.xB3SpanId !== null) {
                            headerParameters['X-B3-SpanId'] = String(requestParameters.xB3SpanId);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/legacy-idp/verify-otc",
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.VerifyOTCRequestToJSON(requestParameters.verifyOTCRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.UserFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * The \'OTC\' and \'app\' request body values are required. > Validation Error Codes:   * `APP_NOT_SUPPORTED`   * `GENERAL_VALIDATION`   * `USER_NOT_AUTHORIZED_FOR_APP`   * `OTC_EXPIRED`   * `OTC_USED`   * `OTC_MISMATCH` > System Error Codes:   * `GENERAL_SYSTEM_ERROR`   * `INTERNAL_DATA_ERROR`
     * verifies if a OTC is valid
     */
    LegacyIDPApi.prototype.verifyOtc = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.verifyOtcRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return LegacyIDPApi;
}(runtime.BaseAPI));
exports.LegacyIDPApi = LegacyIDPApi;
